export const getWindowObject = (): (Window & typeof globalThis) | undefined => {
	return typeof window !== 'undefined' && !!window ? window : undefined;
};

export const getPerformanceObject = (): Performance | undefined => {
	const { performance } = getWindowObject() || {};

	return performance;
};

export const getPerformanceObserverObject = ():
	| {
			new (callback: PerformanceObserverCallback): PerformanceObserver;
			prototype: PerformanceObserver;
			readonly supportedEntryTypes: ReadonlyArray<string>;
	  }
	| undefined => {
	const { PerformanceObserver } = getWindowObject() || {};

	return PerformanceObserver;
};
